const colors = {
  up: 'bg-emerald-400 shadow-[0_0_8px_#34d399]',
  down: 'bg-rose-500 shadow-[0_0_8px_#f43f5e]',
  unknown: 'bg-amber-400 shadow-[0_0_8px_#fbbf24]',
};

const StatusDot = ({ status = 'unknown' }) => (
  <span
    aria-label={status}
    className={`inline-block h-2.5 w-2.5 rounded-full ${colors[status] || colors.unknown}`}
  />
);

export default StatusDot;
